// User action Type
export const SET_AUCTION_TYPE_LIST = "SET_AUCTION_TYPE_LIST";
export const ADD_AUCTION_TYPE = "ADD_AUCTION_TYPE";
export const EDIT_AUCTION_TYPE = "EDIT_AUCTION_TYPE";
export const DELETE_AUCTION_TYPE = "DELETE_AUCTION_TYPE";
